<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-white">
  <path stroke-linecap="round" stroke-linejoin="round" d="M6 7.5V19.5A2.25 2.25 0 0 0 8.25 21.75h7.5A2.25 2.25 0 0 0 18 19.5V7.5M9.75 11.25v4.5m4.5-4.5v4.5M4.5 7.5h15M10.5 3.75h3a.75.75 0 0 1 .75.75v1.5h-4.5v-1.5a.75.75 0 0 1 .75-.75z" />
</svg>
